// initial state
import Dexie from "dexie";

const db = new Dexie("PizzaDB");
db.version(1.1).stores({
    items: "++id,code,data,order_id,timestamp",
    order: "++id,data,order_id,payment_id",
});

const DBUtils = {
    updateBasketItem: function(offerCode, date){
        db.items.where('code').equals(offerCode).first().then(item => {
            item.data = JSON.stringify(date);
            item.timestamp = new Date().getTime();
            db.items.put(item).then();
        });
    },
    updateBasketItemById: function(offer){
        db.items.where(":id").equals(offer.id).modify({timestamp: new Date().getTime(), data: JSON.stringify(offer.data)});
    }
}

const state = () => ({
    items: [],
    isBasketOpen: false,
    isDelivery: true,
    isDeferOrder: false,
    deferOrderDate: null,
    deferOrderTime: null,
    paymentType: 'courier',
    paymentCourierVariant: 'cash',
    noChange: false,
    changeValue: null,
    useBonus: false,
    useBonusValue: 0,
    deliveryAddress: {
        street: {
            ext_id: '',
            title: '',
        },
        house: null,
        building: null,
        entrance: null,
        floor: null,
        flat: null,
        doorphone: null,
    },
    saveAddress: true,
    orderComment: null,
    user: {
        name: '',
        phone: '',
        id: '',
        email: null,
    },
    order:{
        id: null,
        payment_id: null,
        status: 'Processing',
        statusText: 'Заказ в обработке!',
        dateDelivery: null,
        number: null,
        total: {},
        user: {},
        address: {
            street: {}
        },
        productItems: [],
        isDelivery: true,
        isDeferOrder: false
    },
    isCheckout: false,
    isConfirmOrder: false,
    freeProducts: [],
    discounts: [],
    discountSum: 0,
    coupon: null,
    coupon_status: null,
    pizzeria_point_id: null,
    total: {sum: 0, quantity: 0, full_sum: 0, discount_sum: 0, free_sauces_count: 0, delivery_sum: 0},
    errors: [],
})

// getters
const getters = {
    basketItems: (state) => {
        return state.items;
    },
    total: function (state) {
        return state.total;
    },
    getTotalQuantity: function (state){
        return state.items.length;
    },
    isBasketOpen: function (state) {
        return state.isBasketOpen;
    },
    isDelivery: function (state) {
        return state.isDelivery;
    },
    isDeferOrder: function (state) {
        return state.isDeferOrder;
    },
    deferOrderTime: function (state) {
        return state.deferOrderTime;
    },
    getDeferOrderDate: function (state) {
        return state.deferOrderDate;
    },
    isNoChange: function (state) {
        return state.noChange;
    },
    paymentType: function (state) {
        return state.paymentType;
    },
    getPaymentCourierVariant: function (state) {
        return state.paymentCourierVariant;
    },
    getSaveAddress: function (state){
        return state.saveAddress;
    },
    changeValue: function (state) {
        return state.changeValue;
    },
    isUseBonus: function (state) {
        return state.useBonus;
    },
    useBonusValue: function (state) {
        return state.useBonusValue;
    },
    deliveryAddress: function (state) {
        return state.deliveryAddress;
    },
    orderComment: function (state) {
        return state.orderComment;
    },
    getUserInfo: function (state) {
        return state.user;
    },
    getOrderInfo: function (state) {
        return state.order;
    },
    getWaitingTime: function (state) {
        return state.waitingTime;
    },
    getIsCheckout: function (state) {
        return state.isCheckout;
    },
    getIsConfirmOrder: function (state) {
        return state.isConfirmOrder;
    },
    getDiscounts: function (state) {
        return state.discounts;
    },
    getDiscountSum: function (state) {
        return state.total.discount_sum;
    },
    getFreeProducts: function (state){
        return state.freeProducts;
    },
    getCoupon: function (state){
        return state.coupon;
    },
    getCouponStatus: function (state){
        return state.coupon_status;
    },
    getPizzeriaPointId: function (state){
        return state.pizzeria_point_id;
    },
    getOrderErrors: function (state){
        return state.errors;
    },
    getOrderCombos: function (state){
        return state.items.filter(i => { return i.entity !== undefined && i.entity === 'combo'; });
    }
}

// actions
const actions = {
    addToBasket ({ state, commit }, {offer}) {
        if(offer.code === undefined){return false;}
        const basketItem = state.items.find(item => item.code === offer.code);
        if (!basketItem) {
            commit('addProductToBasket', offer);
        } else {
            const sauce = offer.sauces !== undefined ? offer.sauces[(offer.sauces.length - 1)] : undefined;
            const quantity = offer.quantity === undefined ? 1 : offer.quantity;
            commit('changeQuantity', {offer: basketItem, quantity: quantity, sauce: sauce});
        }
    },

    changeQuantity({ state, commit }, {code, quantity, sauces}){
        const basketItem = state.items.find(item => item.code === code);
        if((basketItem.quantity + quantity) === 0){
            commit('removeBasketItem', basketItem.code);
        } else{
            let sauce;
            if(sauces !== undefined){
                const lastSauceIndex = sauces.length - 1;
                sauce = sauces[lastSauceIndex];
            }
            commit('changeQuantity', {offer: basketItem, quantity: quantity, sauce: sauce});
        }
    },

    changeDeliveryType({commit}, {isDelivery}){
        commit('changeDeliveryType', isDelivery);
    },

    changeOrderType({commit}, {isDeferOrder}){
        commit('changeOrderType', isDeferOrder);
    },

    setDeferOrderTime({commit}, {deferOrderTime}){
        commit('setDeferOrderTime', deferOrderTime);
    },

    setDeliveryAddress({commit}, {deliveryAddress}){
        commit('setDeliveryAddress', deliveryAddress);
    },

    changePaymentType({commit}, {paymentType}){
        commit('changePaymentType', paymentType);
    },

    setPaymentCourierVariant({commit}, {paymentCourierVariant}){
        commit('setPaymentCourierVariant', paymentCourierVariant);
    },

    setNoChange({commit}, {noChange}){
        commit('setNoChange', noChange);
    },

    setChangeValue({commit}, {changeValue}){
        commit('setChangeValue', changeValue);
    },

    setUseBonus({commit}, {useBonus}){
        commit('setUseBonus', useBonus);
    },

    setUseBonusValue({commit}, {useBonusValue}){
        commit('setUseBonusValue', useBonusValue);
    },

    setOrderComment({commit}, {orderComment}){
        commit('setOrderComment', orderComment);
    },

    setUserInfo: function ({commit}, {user}) {
        commit('setUserInfo', user);
    },

    saveOrder: function({commit}, {order}){
        const order_id = order.id;
        if(order_id !== undefined) {
            const payment_id = order.payment_id !== undefined ? order.payment_id : null;
            db.order.add({"order_id": order_id, "payment_id": payment_id, "data": JSON.stringify(order.data)}).then(function () {
                if(order_id !== null) {
                    db.transaction('rw', db.items, async () => {
                        db.items.each(item => {
                            if (item.order_id === null) {
                                db.items.update(item.id, {order_id: order_id});
                            }
                        });
                    }).catch(err => {
                        console.error(err.stack);
                    });
                }
                commit('setOrderInfo', Object.assign({id: order_id}, order.data));
            }).catch(function (e) {
                console.error("Error: " + (e.stack || e));
            });
        }
    },

    finishOnlinePayment: async function({commit}, {payment_id, order}){
        await db.transaction('rw', db.order, db.items, async () => {
            db.order.where({'payment_id': payment_id}).first(orderItem => {
                const orderId = order.id;
                if(orderId !== undefined) {
                    const orderObject = Object.assign(JSON.parse(orderItem.data), order);
                    db.order.update(orderItem.id, {data: JSON.stringify(orderObject), order_id: orderId}).then(() => {
                        db.items.each(item => {
                            if (item.order_id === null) {
                                db.items.update(item.id, {order_id: orderId}).catch(err => {
                                    console.error('items', err);
                                });
                            }
                        });
                        commit('setOrderInfo', order);
                    });
                }
            });
        }).catch(error => {
            console.error('finishOnlinePayment', error)
        });
    },

    loadOrderInfo({commit}, {order}){
        const order_id = (order.id !== undefined) ? order.id : null;
        db.order.where({'order_id': order_id}).first(orderItem => {
            if(orderItem !== undefined && orderItem.id !== undefined && !isNaN(orderItem.id)){
                const orderData = JSON.parse(orderItem.data);
                Object.assign(order, orderData);
                commit('setOrderInfo', order);
            }
        });
    },

    setOrderInfo: function ({state, commit}, {order}) {
        const currentOrder = state.order;
        const order_id = (order.id !== undefined) ? order.id : null;
        if(order_id !== null) {
            const order_status = (order.status !== undefined) ? order.status : null;
            if (order_status !== null) {
                const currentStatus = (currentOrder.status !== undefined) ? currentOrder.status : null;
                if (currentStatus !== order_status) {
                    db.order.where({'order_id': order_id}).first(orderItem => {
                        if(orderItem !== undefined && orderItem.id !== undefined && !isNaN(orderItem.id)){
                            const orderData = JSON.parse(orderItem.data);
                            orderData.status = order_status;
                            Object.assign(orderData, order);
                            db.order.update(orderItem.id, {data: JSON.stringify(orderData)});
                            commit('setOrderInfo', orderData);
                        }
                    });
                }
            }else{
                db.order.where({'order_id': order_id}).first(orderItem => {
                    if(orderItem !== undefined && orderItem.id !== undefined && !isNaN(orderItem.id)){
                        const orderData = JSON.parse(orderItem.data);
                        Object.assign(orderData, order);
                        commit('setOrderInfo', order);
                        commit('changeDeliveryType', order.isDelivery);
                        commit('changePaymentType', order.paymentType);
                    }
                });
            }
        }
    },

    setCheckout: function ({commit}, {state}) {
        commit('setCheckout', state);
    },

    setConfirmOrder: function ({commit}, {state}) {
        commit('setConfirmOrder', state);
    },

    closeOrder: function({commit}){
        db.items.toCollection().delete();
        db.order.toCollection().delete();

        commit('closeBasket', false);
        commit('emptyItems');
        commit('setCheckout', false);
        commit('setConfirmOrder', false);
        commit('emptyOrder');
        commit('setUseBonusValue', 0);
    },

    setDiscounts: function({commit}, {discounts}){
        commit('setDiscounts', discounts);
    },

    setTotal: function({commit}, {total}){
        commit('setTotal', total);
    },

    open({ commit }) {
        commit('openBasket', true);
    },

    close({ commit }) {
        commit('closeBasket', false);
    },

    async loadBasket({ commit }, {products}){
        return new Promise((resolve) => {
            const offers = [];
            const updateOffers = [];
            db.items.each(item => {
                const offer = JSON.parse(item.data);
                if(offer.entity !== undefined && offer.entity === 'combo'){
                    offers.push(offer);
                }else {
                    const product = products[offer['group_id']].find(item => item.id === offer.primary_id);
                    if (product !== undefined) {
                        const basketItem = Object.assign(offer);
                        let actualPrice = product.price_from;
                        if (offer.offer_id !== undefined && offer.offer_id !== null &&
                            product.offers !== undefined && product.offers.length > 0) {
                            const productOffer = product.offers.find(o => o.id === offer.offer_id);
                            if (productOffer !== undefined) {
                                actualPrice = productOffer.price;
                            }
                        }
                        if (offer.price !== actualPrice) {
                            Object.assign(basketItem, {price: actualPrice});
                            updateOffers.push({id: item.id, data: basketItem});
                        }
                        offers.push(basketItem);
                    }
                }
            }).then(
                function () {
                    if (updateOffers.length) {
                        for (const index in updateOffers) {
                            DBUtils.updateBasketItemById(updateOffers[index]);
                        }
                    }
                    state.items = offers;
                    commit('setBasket', offers);
                    resolve();
                }
            );
        });
    }
}

// mutations
const mutations = {

    emptyItems(state){
        state.items = [];
    },

    addProductToBasket (state, offer) {
        state.items.push(offer);
        db.items.add({code: offer.code, data: JSON.stringify(offer), order_id: null, timestamp: new Date().getTime()}).then(function() {
            return db.items.toArray();
        }).catch(function (e) {
            console.error("Error: " + (e.stack || e));
        });
    },

    changeQuantity (state, {offer, quantity, sauce}) {
        const basketItem = state.items.find(item => item.code === offer.code);
        if(sauce !== undefined){
            if (quantity > 0) {
                basketItem.sauces.push(sauce);
            } else {
                const lastSauceIndex = basketItem.sauces.length - 1;
                basketItem.sauces = basketItem.sauces.filter((item, index) => index !== lastSauceIndex);
            }
        }
        basketItem.quantity += quantity;

        DBUtils.updateBasketItem(offer.code, basketItem);
        if(state.items.length === 0){
            state.useBonus = false;
            state.useBonusValue = 0;
        }
    },

    updateCombo (state, combo){
        const updatedCombo = Object.assign(state.items.find(item => item.code === combo.code), combo);
        DBUtils.updateBasketItem(combo.code, updatedCombo);
        if(state.items.length === 0){
            state.useBonus = false;
            state.useBonusValue = 0;
        }
    },

    changeDeliveryType(state, isDelivery){
        state.isDelivery = isDelivery;
    },

    changeOrderType(state, isDeferOrder){
        state.isDeferOrder = isDeferOrder;
    },

    setDeferOrderTime(state, deferOrderTime){
        state.deferOrderTime = deferOrderTime;
    },

    setDeferOrderDate(state, deferOrderDate){
        if(state.deferOrderDate === null){
            state.deferOrderDate = deferOrderDate;
        }else {
            state.deferOrderDate = Object.assign(state.deferOrderDate, deferOrderDate);
        }
    },

    setDeliveryAddress(state, deliveryAddress){
        Object.assign(state.deliveryAddress, deliveryAddress);
    },

    setSaveAddress(state, saveAddress){
        state.saveAddress = saveAddress;
    },

    changePaymentType(state, paymentType){
        state.paymentType = paymentType;
    },

    setPaymentCourierVariant(state, paymentCourierVariant){
        state.paymentCourierVariant = paymentCourierVariant;
    },

    setNoChange(state, noChange){
        state.noChange = noChange;
    },

    setChangeValue(state, changeValue){
        state.changeValue = changeValue;
    },

    setUseBonus(state, useBonus){
        state.useBonus = useBonus;
    },

    setUseBonusValue(state, useBonusValue){
        state.useBonusValue = useBonusValue;
    },

    setOrderComment(state, orderComment){
        state.orderComment = orderComment;
    },

    setUserInfo(state, user){
        state.user = Object.assign(state.user, user);
    },

    setOrderInfo(state, order){
        state.order = Object.assign(state.order, order);
    },

    setCheckout(state, isCheckout){
        state.isCheckout = isCheckout;
    },

    setConfirmOrder(state, isConfirmOrder){
        state.isConfirmOrder = isConfirmOrder;
    },

    removeBasketItem(state, code){
        state.items = state.items.filter(item => item.code !== code);
        db.items.where('code').equals(code).delete();
        if(state.items.length <= 0){
            Object.assign(state.total, {sum: 0, quantity: 0, full_sum: 0, discount_sum: 0});
        }
    },

    openBasket(state){
        state.isBasketOpen = true;
    },

    emptyOrder(state){
        state.order = {
            status: 'Processing',
            id: null,
        };
    },

    closeBasket(state){
        state.isBasketOpen = false;
    },

    setBasket(state, offers){
        state.items = offers;
    },

    setDiscounts(state, discounts){
        state.discounts = discounts;
    },

    setTotal(state, total){
        state.total = Object.assign(state.total, total);
    },

    setFreeProducts: function (state, freeProducts){
        state.freeProducts = freeProducts;
    },

    setCoupon: function (state, value){
        state.coupon = value;
    },

    setCouponStatus: function (state, value){
        state.coupon_status = value;
    },

    setPizzeriaPointId: function (state, value){
        state.pizzeria_point_id = value;
    },

    setOrderErrors: function (state, errors){
        state.errors = errors;
    },

    addOrderError: function (state, error){
        state.errors.push(error);
    },

    setDeliverySum: function (state, value){
        state.total.delivery_sum = value;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
